export default function RaceState (
    state = {
        sort_by_bl: false,
        sort_by_class: false,
        history_events: {
            search_string: "",
            filter: {},
            list: {},
            details: {},
            validation: {},
            options: {},
            competitors: [],
            list_pagination: { rpp: 20, max_pages: 0, total_rows: 0, page: 1 },
        },
        history_events_competitors: {
            search_string: "",
            list: {},
            details: {},
            validation: {},
            options: {},
            competitors: [],
        },
        events: { list: [] },
        race_details: {},
        race_competitors: {},
        race_update_type: "",
        refresh: false,
    },
    action
) {
    switch (action.type) {
        case "RACE_DETAILS":
            state.race_details[action.data.race_details.cntrl_id] =
                action.data.race_details;
            state.race_update_type = "race_details";
            return { ...state };
        case "RACE_EVENT_COMPETITOR":
            if (!state.race_competitors[action.data.controller_id])
                state.race_competitors[action.data.controller_id] = {};
            state.race_competitors[action.data.controller_id][
                action.data.competitor.nr
            ] = action.data.competitor;
            state.refresh = !state.refresh;
            state.race_update_type = "competitor";
            return { ...state };
        case "RACE_EVENT":
        case "RACE_EVENT_DETAILS":
            state.race_details[action.data.race_details.cntrl_id] =
                action.data.race_details;
            state.race_competitors[action.data.race_details.cntrl_id] =
                action.data.race_competitors;
            state.refresh = !state.refresh;
            state.race_update_type = "race";
            return { ...state };
        case "RACE_EVENTS_LIST":
            //this is object array not array list
            state.race_details = action.data;
            state.refresh = !state.refresh;
            return { ...state };
        case "EVENT_SELECTED":
            state.events.selected = action.value;
            return { ...state };
        case "EVENT_DESELECTED":
            state.events.selected = null;
            return { ...state };
        case "RACE_RESULT_SORT":
            state[action.field] = action.value;
            return { ...state };
        case "RACE_HISTORY_EVENT_SEARCH":
            //this is array list
            state.history_events.list = action.data.list;
            state.history_events.list_pagination = action.data.list_pagination;
            return { ...state };
        case "HISTORY_EVENT_UPDATE_FILTER_STRING":
            state.history_events.filter = action.value;
            return { ...state };
        case "HISTORY_EVENT_UPDATE_SEARCH_STRING":
            state.history_events.search_string = action.value;
            return { ...state };
        case "HISTORY_EVENT_RPP_CHANGED":
            state.history_events.list_pagination.rpp = action.value;
            return { ...state };
        case "HISTORY_EVENT_SET_PAGE":
            state.history_events.list_pagination.page = action.value;
            return { ...state };
        case "RACE_HISTORY_EVENT_VALIDATION_ERROR":
            state.history_events.validation = action.data;
            return { ...state };
        case "RACE_HISTORY_EVENT_OPTIONS":
            state.history_events.options = action.data.options;
            return { ...state };
        case "RACE_HISTORY_EVENT_DETAILS":
            state.history_events.details = action.data.record;
            return { ...state };
        case "RACE_HISTORY_EVENT_LINKED_LIST":
            state.history_events.competitors = action.data;
            return { ...state };
        case "HISTORY_EVENT_SELECTED":
            state.history_events.selected = action.value;
            return { ...state };
        case "HISTORY_EVENT_DESELECTED":
            state.history_events.selected = null;
            return { ...state };
        case "RACE_HISTORY_UPDATE_FORM":
            console.log(action);
            state.history_events.details[action.field] = action.value;
            if (state.history_events.validation[action.field]) {
                state.history_events.validation[action.field] = {};
            }
            return { ...state };
        default:
            break;
    }
    return state;
}
